import MainComponent from './MainScreenWithTabs';

export default MainComponent;